import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import Page from 'flarum/common/components/Page';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import humanTime from 'flarum/common/utils/humanTime';
import Icon from 'flarum/common/components/Icon';
import PageStructure from 'flarum/forum/components/PageStructure';
import IssueList from './IssueList';
import Hero from './Hero';
import ProgressBar from 'ext:sycho/flarum-uikit/common/components/ProgressBar';
import IssueListState from '../states/IssueListState';
import Stream from 'flarum/common/utils/Stream';
export default class MilestonePage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "settings", {});
    _defineProperty(this, "milestone", void 0);
    _defineProperty(this, "activeState", Stream(app.forum.attribute('sycho-github-milestone.default_filter') || 'all'));
  }
  oninit(vnode) {
    var _app$forum$attribute, _app$forum$attribute2;
    super.oninit(vnode);
    this.state = new IssueListState();
    this.settings = {
      repository: {
        owner: (_app$forum$attribute = app.forum.attribute('sycho-github-milestone.repository')) == null ? void 0 : _app$forum$attribute.split('/')[0],
        name: (_app$forum$attribute2 = app.forum.attribute('sycho-github-milestone.repository')) == null ? void 0 : _app$forum$attribute2.split('/')[1]
      },
      milestone: app.forum.attribute('sycho-github-milestone.milestone_id')
    };
    if (!this.settings.repository.owner || !this.settings.repository.name || !this.settings.milestone) {
      m.route.set('/');
      return;
    }
    this.state.refresh().then(() => {
      this.milestone = app.store.all('github-milestones')[0];
    });
  }
  view() {
    return m(PageStructure, {
      loading: this.state.isLoading(),
      className: "MilestonePage",
      sidebar: () => m(IndexSidebar, null),
      hero: () => m(Hero, {
        title: this.milestone.title(),
        subtitle: [m("div", {
          className: "GithubMilestone-details"
        }, listItems(this.milestoneDetails().toArray())), m(ProgressBar, {
          fancy: true,
          alternate: true,
          progress: this.progress()
        })]
      })
    }, this.state.isLoading() ? m(LoadingIndicator, null) : m(IssueList, {
      state: this.state,
      milestone: this.milestone,
      activeState: this.activeState
    }));
  }
  milestoneDetails() {
    const items = new ItemList();
    items.add('updatedAt', m("div", {
      className: "GithubMilestone-detailsItem"
    }, m("strong", null, m(Icon, {
      name: "fas fa-clock"
    })), ' ', app.translator.trans('sycho-github-milestone.forum.last_updated', {
      time: humanTime(this.milestone.updatedAt())
    })));
    items.add('openIssues', m("div", {
      className: "GithubMilestone-detailsItem"
    }, m("strong", null, this.milestone.openIssues()), " ", app.translator.trans('sycho-github-milestone.forum.open')));
    items.add('closedIssues', m("div", {
      className: "GithubMilestone-detailsItem"
    }, m("strong", null, this.milestone.closedIssues()), " ", app.translator.trans('sycho-github-milestone.forum.closed')));
    items.add('progress', m("div", {
      className: "GithubMilestone-detailsItem"
    }, app.translator.trans('sycho-github-milestone.forum.complete', {
      progress: this.progress()
    })));
    return items;
  }
  progress() {
    if (!this.milestone) return 0;
    return Math.round(this.milestone.closedIssues() * 100 / (this.milestone.closedIssues() + this.milestone.openIssues()));
  }
}
flarum.reg.add('sycho-github-milestone', 'forum/components/MilestonePage', MilestonePage);